module.exports = __webpack_public_path__ + "img/super.999c62f8.jpg";